import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { NAV_LINKS } from "./navLinks";
import { useScrollLock } from "../../hooks/useScrollLock";

export default function PageNavbar() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useScrollLock(menuOpen);

  return (
    <nav
      className="sticky top-0 z-50 w-full"
      style={{
        background: "#000",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        fontFamily: "'Space Grotesk', system-ui, sans-serif",
      }}
    >
      <div
        className="mx-auto flex items-center justify-between"
        style={{ maxWidth: 1440, padding: "14px 16px", paddingLeft: "16px", paddingRight: "16px" }}
      >
        <Link
          to="/"
          style={{
            fontSize: 17,
            fontWeight: 700,
            color: "#ECECEC",
            textDecoration: "none",
            letterSpacing: -0.2,
          }}
        >
          Intellivex LTD
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((link) => {
            const isActive = pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="whitespace-nowrap cursor-pointer"
                style={{
                  color: isActive ? "#93C5FD" : "#8A8A8A",
                  textDecoration: "none",
                  fontSize: 13,
                  fontWeight: 500,
                  padding: "7px 14px",
                  borderRadius: 9999,
                  background: isActive
                    ? "rgba(147,197,253,0.1)"
                    : "transparent",
                  transition: "color 0.3s ease, background 0.3s ease",
                }}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex items-center justify-center cursor-pointer"
          style={{
            width: 40,
            height: 40,
            background: "transparent",
            border: "none",
            color: "#ECECEC",
          }}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          <div style={{ position: "relative", width: 22, height: 16 }}>
            <span
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 22,
                height: 2,
                borderRadius: 2,
                background: "#ECECEC",
                transform: menuOpen ? "translateY(7px) rotate(45deg)" : "none",
                transition: "transform 0.3s ease",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: 7,
                left: 0,
                width: 22,
                height: 2,
                borderRadius: 2,
                background: "#ECECEC",
                opacity: menuOpen ? 0 : 1,
                transition: "opacity 0.2s ease",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: 14,
                left: 0,
                width: 22,
                height: 2,
                borderRadius: 2,
                background: "#ECECEC",
                transform: menuOpen ? "translateY(-7px) rotate(-45deg)" : "none",
                transition: "transform 0.3s ease",
              }}
            />
          </div>
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "100%",
          height: "100vh",
          background: "rgba(0,0,0,0.6)",
          backdropFilter: "blur(4px)",
          zIndex: 40,
          opacity: menuOpen ? 1 : 0,
          pointerEvents: menuOpen ? "auto" : "none",
          transition: "opacity 0.35s ease",
        }}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "min(320px, 85vw)",
          height: "100vh",
          background: "#0D0D0D",
          zIndex: 45,
          padding: "24px 20px",
          transform: menuOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1)",
          fontFamily: "'Space Grotesk', system-ui, sans-serif",
        }}
      >
        <div className="flex items-center justify-between mb-10">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "#ECECEC",
              textDecoration: "none",
              letterSpacing: -0.2,
            }}
          >
            Intellivex LTD
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen(false)}
            className="flex items-center justify-center cursor-pointer"
            style={{
              width: 36,
              height: 36,
              background: "transparent",
              border: "none",
              color: "#8A8A8A",
              fontSize: 22,
            }}
            aria-label="Close menu"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="flex flex-col" style={{ gap: 4 }}>
          {NAV_LINKS.map((link) => {
            const isActive = pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap cursor-pointer flex items-center"
                style={{
                  color: isActive ? "#93C5FD" : "#ECECEC",
                  textDecoration: "none",
                  fontSize: 20,
                  fontWeight: 500,
                  padding: "14px 12px",
                  borderRadius: 12,
                  background: isActive
                    ? "rgba(147,197,253,0.08)"
                    : "transparent",
                  transition: "color 0.3s ease, background 0.3s ease",
                  letterSpacing: "-0.01em",
                }}
              >
                {link.label}
                {isActive && (
                  <span
                    style={{
                      marginLeft: "auto",
                      width: 6,
                      height: 6,
                      borderRadius: 9999,
                      background: "#93C5FD",
                    }}
                  />
                )}
              </Link>
            );
          })}
        </div>

        <div
          style={{
            position: "absolute",
            bottom: 40,
            left: 20,
            right: 20,
            borderTop: "1px solid rgba(255,255,255,0.08)",
            paddingTop: 20,
          }}
        >
          <Link
            to="/contact-us"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap cursor-pointer flex items-center justify-center"
            style={{
              background: "#2563EB",
              color: "#ECECEC",
              border: "none",
              borderRadius: 9999,
              padding: "13px 0",
              fontWeight: 600,
              fontSize: 15,
              textDecoration: "none",
              width: "100%",
            }}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </nav>
  );
}